import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import AssignmentRestrictionModal from '@/components/Form/components/AssignmentRestriction/components/AssignmentRestrictionModal';
import { DEFAULT_ASSIGNMENT_RESTRICTION } from '@/components/Form/components/AssignmentRestriction/consts';
import { AssignmentRestrictionType } from '@/types/schema';

import { DialogProps } from '../../types';

const AssignmentRestriction: React.FC<DialogProps> = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();
  const assignmentRestriction =
    (content.assignmentRestriction as AssignmentRestrictionType) || DEFAULT_ASSIGNMENT_RESTRICTION;

  const onSubmitHandler = useCallback(
    async (assignmentRestriction: any) => {
      return onSubmit?.({
        assignmentRestriction,
      });
    },
    [onSubmit],
  );

  return (
    <AssignmentRestrictionModal
      assignmentRestriction={assignmentRestriction}
      contentName={t('Common:ResourceType.Article')}
      onClose={onClose}
      onSubmit={onSubmitHandler}
    />
  );
};

export default AssignmentRestriction;
